import WhatsAppMessagesTable from "./whatsapp";
export default WhatsAppMessagesTable;
